var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--text-primary)",
    d: "M37.525 4.85l-9.567 9.566.844.915c1.477 1.477 1.759 3.658.774 5.416l-8.934 16.11a2.332 2.332 0 01-1.97 1.125c-.633 0-1.196-.21-1.618-.633L2.634 22.93C2.21 22.505 2 21.942 2 21.31c0-.774.422-1.547 1.126-1.97l16.109-8.934c1.759-.984 3.94-.703 5.417.774l.914.844 9.567-9.496c.633-.704 1.689-.704 2.392 0a1.656 1.656 0 010 2.321zM24.722 22.505l-7.246-7.246L6.08 21.592l2.251 2.25 3.799-1.195c.492-.211.914.21.774.703l-1.267 3.799 6.754 6.753 6.331-11.396z"
  })));
}
export default SvgClear;